export default "__VITE_PUBLIC_ASSET__b631c5da__"